import { Component, OnInit } from "@angular/core";
import { UserService } from "../../services/user.service";
import { Router, ActivatedRoute } from "@angular/router";
import { NgForm } from "@angular/forms";
import { UtilityService } from "../../services/utility.service";
//import { DatePipe } from '@angular/common';
//import { UpdateNameService } from '../../services/update-name.service'

@Component({
  selector: "app-add-user",
  templateUrl: "./add-user.component.html",
  styleUrls: ["./add-user.component.css"],
})
export class AddUserComponent implements OnInit {
  model: any = { roles: "" };

  response: any = {};
  userId: string = "0";
  role = +localStorage.getItem("role");
  roleList = [];
  tripList: any = [];
  public mask = [
    "(",
    /[1-9]/,
    /\d/,
    /\d/,
    ")",
    " ",
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ];
  constructor(
    private _userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private _utilityService: UtilityService
  ) {}
  ngOnInit() {
    this.roleList = this._utilityService.getRoles();
    this.userId = JSON.parse(localStorage.getItem("user")).id;
    if (this.userId) {
      let currentYear = new Date().getFullYear();
      let previousYear = currentYear - 1;
      this._userService.getTripOptionListActive().subscribe((result) => {
        this.tripList = result.filter(
          (t) => !t.isOptional && t.years >= previousYear.toString()
        );
        this.getUserDetail();
      });
    }
  }

  getUserDetail() {
    this.model = { Id: this.userId };
    this._userService.getUserDetail(this.model).subscribe((result) => {
      this.model = result.data;
      this.model.tripId = this.model.tripId ? this.model.tripId : "";
      //console.log(this.model);
      //this.model.yearEndClosingDate = this.model.yearEndClosingDateDisplay ? new Date(this.model.yearEndClosingDateDisplay) : null;
    });
  }
  setMinCheckoutDate(filterValue: string) {
    this.model.yearEndClosingDate = filterValue;
  }
  addUpdate(form: NgForm) {
    if (form.valid) {
      this.model.tripId = +this.model.tripId;
      this.model.YearEndClosingDateString = this.model.yearEndClosingDate
        ? new Date(this.model.yearEndClosingDate).toDateString()
        : "";
      this.model.LogUserId = this._utilityService.getCurrentUserId();

      this._userService.saveUserDetail(this.model).subscribe((result) => {
        if (result) {
          this.response = result;
          if (this.response.messageCode == 1) {
            localStorage.setItem("user", JSON.stringify(result.data));
            this.model.tripId = this.model.tripId ? this.model.tripId : "";
            this.router.navigate(["/update-profile"]);
          }
          //this.getUserDetail();
        }
      });
    } else {
      let invalidFields = [].slice.call(
        document.getElementsByClassName("ng-invalid")
      );
      invalidFields[1].focus();
    }
  }
  numberOnlyWithDecimals(event: KeyboardEvent): boolean {
    const allowedKeys = [
      "Backspace",
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
      "Home",
      "End",
    ];

    const input = event.target as HTMLInputElement;

    // Allow control keys
    if (allowedKeys.includes(event.key)) {
      return true;
    }

    // Allow single dot
    if (event.key === ".") {
      if (input.value.includes(".")) {
        return false;
      }
      return true;
    }

    // Allow digits 0–9
    if (/^[0-9]$/.test(event.key)) {
      const { selectionStart, selectionEnd } = input;
      const newValue =
        input.value.substring(0, selectionStart!) +
        event.key +
        input.value.substring(selectionEnd!);

      // If decimal part exists, limit to 1 digit after dot
      const parts = newValue.split(".");
      if (parts.length === 2 && parts[1].length > 2) {
        return false;
      }
      return true;
    }
    return false;
  }

  numberOnlyWithDecimal(event): boolean {
    var dotCount = 0;
    var checkNumberOnly = "";
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode == 46) {
      dotCount += 1;
      checkNumberOnly = event.target.value;
      var numericCheck = event.target.value.toString();
      if (numericCheck.includes(".")) {
        dotCount += 1;
      }
      if (dotCount > 1) {
        dotCount = 0;
        return false;
      }
    }
    if (charCode > 31 && (charCode < 45 || charCode > 57 || charCode == 47)) {
      return false;
    }
    checkNumberOnly = event.target.value;
    var checkString = "";
    if (checkNumberOnly != null) {
      var numeric = event.target.value.toString();
      if (numeric.includes(".")) {
        var checkNumeric = numeric.split(".");
        if (checkNumeric.length > 2) {
          return false;
        }
        checkString = checkNumeric[1].split("");
        if (checkString.length > 1) {
          return false;
        }
      }
    }
    dotCount = 0;
    return true;
  }
}
